let dev = false;
let apiURL,imageURL,webURL
if (dev) {
    apiURL = 'https://dev-admin.dawasaan.com/';
    imageURL = 'https://dev-admin.dawasaan.com';    
    webURL = 'http://localhost:3000/';    
} else {
    apiURL ='https://admin.dawaasaan.com/'
    imageURL ='https://admin.dawaasaan.com/'
    webURL ='https://dawaasaan.com/'
    // webURL = 'http://localhost:3000/';    

}

export { apiURL,imageURL, webURL };
